import React, { useEffect } from "react";
import { connect } from "react-redux";
import CardReport from "./CardReport";
import FilterDateReport from "./FilterDateReport";
import HeaderReport from "./HeaderReport";
import TabSeparationReport from "./TabSeparationReport";
import ChartReport from "./ChartReport";
import TableReport from "./TableReport";
import reportAction from "../../../store/actions/reportCampaignAction";
import typeCampaignCategorySelected from "./TypeCampaignCategorySelected";
import BrowserData from "./BrowserData";

const ComponentReport = ({
  campaignTypeCategorySelected,
  dateFrom,
  dateTo,
  eventDataChart,
  whichSeparationActive,
  getReportAllCampaign,
  getReportAllCampaignPieChart,
  getReportAllCampaignLineChart,
}) => {
  useEffect(() => {
    getReportAllCampaign({
      date_from: dateFrom,
      date_to: dateTo,
    });
    getReportAllCampaignPieChart({
      date_from: dateFrom,
      date_to: dateTo,
    });
    getReportAllCampaignLineChart({
      date_from: dateFrom,
      date_to: dateTo,
    });
  }, []);

  return (
    <>
      <div id="report-top-header-container" className="w-100 bg-secondary">
        <HeaderReport />
        <FilterDateReport />
        <CardReport />
      </div>
      <div
        id="report-chart-and-table-container"
        className="border border-success w-100 rounded my-3"
      >
        <TabSeparationReport />
        <ChartReport />
        <BrowserData />
        <TableReport />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    campaignTypeCategorySelected:
      state.reportCampaign.campaign_type_category_selected,
    dateFrom: state.reportCampaign.date_from,
    dateTo: state.reportCampaign.date_to,
    eventDataChart: state.reportCampaign.event_data_chart,
    whichSeparationActive: state.reportCampaign.which_separation_active,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getReportAllCampaign: (action) => {
      dispatch({
        type: reportAction.GET_REPORT_ALL_CAMPAIGN,
        payload: action,
      });
    },
    getReportAllCampaignPieChart: (action) => {
      dispatch({
        type: reportAction.GET_ALL_CAMPAIGN_REPORT_PIE_CHART,
        payload: action,
      });
    },
    getReportAllCampaignLineChart: (action) => {
      dispatch({
        type: reportAction.GET_ALL_CAMPAIGN_REPORT_LINE_CHART,
        payload: action,
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ComponentReport);
